<template>
  <div>
    <v-row class="row-menu-right mb-3 pl-3 pr-3">
      <v-btn
        rounded
        color="success"
        dark
        class="mr-2"
        @click="gotocreate"
      >
      <v-icon left dark color="white">fa-plus-circle</v-icon>
      Create
      </v-btn>
      <!-- <v-btn
        rounded
        color="blue-grey"
        dark
        class="mr-2"
      >
      <v-icon left dark color="white">mdi-cloud-upload</v-icon>
      Import
      </v-btn>
      <v-btn
        rounded
        color="#2196F3"
        dark
      >
      <v-icon left dark color="white" small>fa-file-export</v-icon>
      Export
      </v-btn> -->
    </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        :headers="headers"
        :items="agencyData"
        class="border-table-employee"
        item-key="_id"
        group-by="สายงานบังคับบัญชา"
        :expanded.sync="expanded"
        :loading="loading"
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
      >
      <template v-slot:[`item.no`]="{ item }">
        {{ (perPage*(page-1)) + agencyData.indexOf(item)+1 }}
      </template>
      <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length">
            <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
            สายงานบังคับบัญชา: {{ group }}
        </td>
      </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                class="btn-edit-dep mt-3 mb-3"
                @click="manageAgency(item)"
              >
              <v-icon dark color="white" small>fa-wrench</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">จัดการหน่วยงาน</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                dark
                icon
                class="btn-member-dep mt-3 mb-3 ml-2"
                @click="goDialogMember(item._id)"
              >
              <v-icon dark color="white" small>fa-users</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">รายชื่อสมาขิก</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
    <DialogMember/>
  </div>
</template>

<script>
import { getSelectAgency, getAgencyList } from '@/API/API'
import { OverlayLoading } from '@/components/index'
import { EventBus } from '@/EventBus'
import DialogMember from '../../_template/member/dialogMember'

export default {
  components: {
    OverlayLoading, DialogMember
  },
  data () {
    return {
      expanded: [],
      keywordworkName: [],
      keywordCompanyName: '',
      keywordHeader: '',
      keywordGroupCompanyName: '',
      keywordUserName: '',
      keywordUserPosition: '',
      loading: true,
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '5%',
          groupable: false,
          sortable: false
        },
        { text: 'ชื่อหน่วยงาน', value: 'orgChartName' },
        // { text: 'สายงานบังคับบัญชา', value: 'orgChartHeaderName' },
        { text: 'ชื่อย่อบริษัท', value: 'companyShortNameEng' },
        { text: 'ชื่อเครือ', value: 'groupCompanyName' },
        { text: 'Action', align: 'center', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' }
      ],
      mockup: [],
      selectData: [],
      agencyData: [],
      total: -1,
      perPage: 15,
      page: 1
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  mounted () {
    EventBus.$on('filterAgency', this.getSelect)
  },
  methods: {
    collapseAll () {
      this.$refs.expandableTable.collapseAll()
    },
    expandAll () {
      this.$refs.expandableTable.expandAll()
    },
    getSelect (data) {
      this.keywordworkName = data.name
      this.keywordCompanyName = data.companyName
      this.keywordHeader = data.header
      this.keywordGroupCompanyName = data.groupCompany
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.initDataTable()
    },
    initData () {
      this.initSelectData()
      this.initDataTable()
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.tokenUser

      try {
        const res = await getSelectAgency(token)

        if (res.success) {
          if (res.result.length) {
            this.selectData = res.result
          }
        } else {
          // console.log(res)
        }
        EventBus.$emit('getFilterAgency', this.selectData)
        EventBus.$emit('selectAgency', res.result)
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    async initDataTable () {
      this.loading = true
      this.agencyData = []
      const temp = []
      var obj = {
        name: this.keywordworkName,
        companyName: this.keywordCompanyName,
        header: this.keywordHeader,
        groupCompany: this.keywordGroupCompanyName,
        limit: this.perPage,
        page: this.page
      }

      try {
        const res = await getAgencyList(obj, this.tokenUser)
        if (res.result) {
          this.isLoading = false
          this.value = res.result
          if (this.value.length) {
            this.value.map((el, index) => {
              el.orgChartHeaderName = ''
              temp.push({
                no: index + 1,
                สายงานบังคับบัญชา: el.orgChartHeaderName,
                ...el
              })
            })
            this.total = res?.count || -1
            this.agencyData = temp
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    goDialogMember (id) {
      EventBus.$emit('opendialogmember', true, id)
    },
    manageAgency (data) {
      this.$router.push({
        name: 'manageAgencyUpdate',
        params: {
          item: data,
          id: data._id
        }
      })
    },
    gotocreate () {
      this.$router.push('manageagency/create')
    }
  }
}
</script>
